import { exportToExcel } from './exportDataToExcel';
import { EnterpriseProject } from '../../../store/account/enterprise';
import { LanguageType } from '../../../types';
import { EnterpriseMember } from '../../../pages/EnterpriseAdmin/Projects/useGetAllUsersInEnterpriseProjects';

export function exportProjectCollaborators(
	users: EnterpriseMember[],
	projectsData: EnterpriseProject[],
	language: LanguageType
) {
	const dictionary = DICTIONARY[language];

	const headers = {
		userType: dictionary.userType,
		name: dictionary.name,
		email: dictionary.emailAddress,
		organization: dictionary.organization,
		projectId: dictionary.projectId,
		projects: dictionary.projects,
		firstAdded: dictionary.firstAdded
	};

	const excelData = users.flatMap(user => {
		const {
			userFirstName,
			userSirName,
			emailAddress,
			organization,
			userType,
			firstTimeAdded,
			projects = []
		} = user;

		const baseData = {
			[headers.userType]: userType,
			[headers.name]: `${userFirstName} ${userSirName}`.trim(),
			[headers.email]: emailAddress,
			[headers.organization]: organization,
			[headers.firstAdded]: firstTimeAdded
		};

		if (projects.length === 0) {
			return [
				{
					...baseData,
					[headers.projects]: ''
				}
			];
		}

		return projects.map(({ projectId }) => {
			const project = projectsData.find(p => p.projectId === projectId);
			return {
				...baseData,
				[headers.projectId]: projectId,
				[headers.projects]: project?.projectName
			};
		});
	});

	exportToExcel(excelData, 'Enterprise_Collaborators');
}

const DICTIONARY = {
	[LanguageType.English]: {
		userType: 'User Type',
		name: 'Name',
		emailAddress: 'Email Address',
		organization: 'Organization',
		projectId: 'Project ID',
		projects: 'Projects',
		firstAdded: 'Joined on'
	},
	[LanguageType.Norwegian]: {
		userType: 'Brukertype',
		name: 'Navn',
		emailAddress: 'E-postadresse',
		organization: 'Organisasjon',
		projectId: 'Prosjekt ID',
		projects: 'Prosjekter',
		firstAdded: 'Lagt til den'
	}
};
